function transformJsonDataQueryToGenerateStateOptimized(jsonDataQuery) {
    if (!jsonDataQuery || typeof jsonDataQuery !== 'object') {
        return null;
    }
    function addPathsRecursively(node, parentPath = []) {
        if (!node || typeof node !== 'object' || !('id' in node)) {
            return null;
        }
        const currentPath = [...parentPath, node.id];

        // Create a shallow copy of the node
        const processedNode = {
            ...node,
            path: currentPath,
            children1: {}
        };

        // Process children
        if (node.children1) {
            if (Array.isArray(node.children1)) {
                // Convert array to object format and add paths
                node.children1.forEach((child) => {
                    if (child && typeof child === 'object' && 'id' in child) {
                        processedNode.children1[child.id] = addPathsRecursively(child, currentPath);
                    }
                });
            } else if (typeof node.children1 === 'object') {
                Object.keys(node.children1 || {}).forEach((childId) => {
                    if (node.children1[childId] && typeof node.children1[childId] === 'object' && 'id' in node.children1[childId]) {
                        processedNode.children1[childId] = addPathsRecursively(
                            node.children1[childId],
                            currentPath
                        );
                    }
                });
            }
        }

        return processedNode;
    }

    return addPathsRecursively(jsonDataQuery);
}

export default transformJsonDataQueryToGenerateStateOptimized;